module.exports = "/_next/static/videos/robot-open-arm-207186688c92ab4d94f4c114f4359075.mp4";